import createIcon from '../../createIcon';

/**
 * @component @name ElectricalServices
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgMTRDMjEgMTMuNDUgMjAuNTUgMTMgMjAgMTNIMThWMTVIMjBDMjAuNTUgMTUgMjEgMTQuNTUgMjEgMTRaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMjAgMTdIMThWMTlIMjBDMjAuNTUgMTkgMjEgMTguNTUgMjEgMThDMjEgMTcuNDUgMjAuNTUgMTcgMjAgMTdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTIgMTRIMTBWMThIMTJDMTIgMTkuMSAxMi45IDIwIDE0IDIwSDE3VjEySDE0QzEyLjkgMTIgMTIgMTIuOSAxMiAxNFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik01IDEzQzUgMTEuOSA1LjkgMTEgNyAxMUg4LjVDMTAuNDMgMTEgMTIgOS40MyAxMiA3LjVDMTIgNS41NyAxMC40MyA0IDguNSA0SDVDNC40NSA0IDQgNC40NSA0IDVDNCA1LjU1IDQuNDUgNiA1IDZIOC41QzkuMzMgNiAxMCA2LjY3IDEwIDcuNUMxMCA4LjMzIDkuMzMgOSA4LjUgOUg3QzQuNzkgOSAzIDEwLjc5IDMgMTNDMyAxNS4yMSA0Ljc5IDE3IDcgMTdIOVYxNUg3QzUuOSAxNSA1IDE0LjEgNSAxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ElectricalServices = createIcon('ElectricalServices', [
  [
    'path',
    { d: 'M21 14C21 13.45 20.55 13 20 13H18V15H20C20.55 15 21 14.55 21 14Z', key: '1mh8du' },
  ],
  [
    'path',
    { d: 'M20 17H18V19H20C20.55 19 21 18.55 21 18C21 17.45 20.55 17 20 17Z', key: '1utnqa' },
  ],
  [
    'path',
    { d: 'M12 14H10V18H12C12 19.1 12.9 20 14 20H17V12H14C12.9 12 12 12.9 12 14Z', key: '1i18br' },
  ],
  [
    'path',
    {
      d: 'M5 13C5 11.9 5.9 11 7 11H8.5C10.43 11 12 9.43 12 7.5C12 5.57 10.43 4 8.5 4H5C4.45 4 4 4.45 4 5C4 5.55 4.45 6 5 6H8.5C9.33 6 10 6.67 10 7.5C10 8.33 9.33 9 8.5 9H7C4.79 9 3 10.79 3 13C3 15.21 4.79 17 7 17H9V15H7C5.9 15 5 14.1 5 13Z',
      key: 'qgikl2',
    },
  ],
]);

export default ElectricalServices;
